/**
 * NB1 (plan Task 7) - the deal's ONE occupied tenant, or null. The rule the analysis screen's lease-type detection already
 * uses: a tenant row with a name that is not "vacant". The Benchmark panel shows only on a single-tenant deal (brief
 * section 6); the lease end goes on AS THE OM STATES IT - the server says when it is not a calendar day.
 */
export interface SingleTenant { tenant_name: string; lease_end: string | null; lease_type: string | null }

type TenantRow = { tenant_name?: unknown; lease_end?: unknown; lease_type?: unknown };
const text = (v: unknown): string | null => (typeof v === 'string' && v.trim() ? v.trim() : null);

export const singleTenantOf = (additional: unknown): SingleTenant | null => {
  const tenants = (additional as { tenants?: unknown } | null | undefined)?.tenants;
  if (!Array.isArray(tenants)) return null;
  const occupied = (tenants as TenantRow[]).filter((t) => {
    const name = text(t?.tenant_name);
    return name !== null && !name.toLowerCase().includes('vacant');
  });
  if (occupied.length !== 1) return null;
  const t = occupied[0];
  return { tenant_name: text(t.tenant_name)!, lease_end: text(t.lease_end), lease_type: text(t.lease_type) };
};
